// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__7wlww","fadeInOut":"styles_fadeInOut__Ss_FR","loader":"styles_loader__2DwsG"};